<template>
  <div class="container col-lg-8 col-sm-12">
    <BaseListToolbar title="Applications" hideSearchBar />
    <div v-if="isLoadingApplications">
      <v-skeleton-loader v-for="i in 10" :key="i" type="list-item" />
    </div>
    <div v-else>
      <div v-if="isNotEmpty">
        <v-list-item
          v-for="application in filteredApplications"
          :key="application.id"
          @click="() => handleSelect(application)"
        >
          <ApplicationListItem :application="application" />
        </v-list-item>
        <v-pagination
          v-if="showPagination"
          :total-visible="page.pageSize"
          v-model="page.currentPage"
          @input="loadApplications"
          :length="page.lastPage"
        />
      </div>
      <EmptyStates
        v-else
        icon="applications-empty-state"
        description="You haven't made any applications yet"
      />
    </div>
  </div>
</template>

<script>
import ApplicationListItem from "@/views/applications/components/ApplicationListItem";
import { APPLICATION_NAMESPACE } from "@/store/modules/applications";
import {
  GET_ALL_APPLICATIONS,
  GET_IS_LOADING_ALL_APPLICATIONS
} from "@/store/modules/applications/getters";
import { FETCH_ALL_APPLICATIONS } from "@/store/modules/applications/actions";
import { createNamespacedHelpers } from "vuex";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import BaseListToolbar from "@/components/common/Toolbar/BaseListToolbar";
import { filter, size } from "lodash";
import EmptyStates from "@/components/common/EmptyStates";
import { paginationMixin } from "@/mixins/pagination.mixin";

const { mapActions, mapGetters } = createNamespacedHelpers(
  APPLICATION_NAMESPACE
);

const { mapState: mapAuthState } = createNamespacedHelpers(AUTH_NAMESPACE);

export default {
  title: "Applications - Track",
  name: "Applications",
  mixins: [paginationMixin],
  components: {
    ApplicationListItem,
    BaseListToolbar,
    EmptyStates
  },
  created() {
    this.loadApplications();
  },
  computed: {
    ...mapAuthState({
      self: state => state.userData
    }),
    ...mapGetters({
      allApplications: GET_ALL_APPLICATIONS,
      isLoadingApplications: GET_IS_LOADING_ALL_APPLICATIONS
    }),
    filteredApplications() {
      return filter(
        this.allApplications,
        application => application.status && application.booking
      );
    },
    requestParams() {
      return {
        filter: {
          user_id: this.self.id
        },
        ...this.requestPageParams
      };
    },
    isNotEmpty() {
      return size(this.filteredApplications);
    }
  },
  methods: {
    ...mapActions({
      fetchAllApplications: FETCH_ALL_APPLICATIONS
    }),
    async loadApplications() {
      const data = await this.fetchAllApplications(this.requestParams);
      if (data) {
        this.updatePageDetails(data.meta);
      }
    },
    handleSelect(application) {
      if (application.status !== "draft") {
        this.$router.push({
          name: "applicationRole",
          params: { id: application.id }
        });
      } else {
        this.$router.push({
          path: "profile",
          query: { booking_id: application.booking.id }
        });
      }
    }
  }
};
</script>
